// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"ExcelImportErrorsTable_checkmark__1IWc1"};